<template>
  <nav class="navbar navbar-expand-lg navbar-light" >
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button class="navbar-toggler navbar-burger" type="button" @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar" aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">        
        <ul class="navbar-nav ml-auto">
          <b-navbar-nav class="ml-auto">
            <b-navbar-nav class="ml-auto">
              <b-nav-item link-classes="text-truncate" class="empresa" @click="mudarDepartamento">
                <div v-if="departamento && departamento.id">
                  {{ departamento.sigla }} - {{ departamento.nome }}
                </div>
              </b-nav-item>
              <b-nav-item-dropdown v-if="usuario && departamento.nome" right>
                <template #button-content>
                  <b-icon icon="person-fill"></b-icon>
                  {{ usuario.nome }}
                </template>

                <b-dropdown-item @click="logout">Sair</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-navbar-nav>
          <lg-mudar-departamento-modal ref="modalDepartamento" />
        </ul>
      </div>
    </div>
  </nav>
</template>
<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-extra-boolean-cast -->
<!-- eslint-disable no-undef -->

<script>

import { getContext, hasContext, logout, isUserAdmin } from '@/core/auth';
import LgMudarDepartamentoModal from '@/core/components/LgMudarDepartamentoModal.vue';

export default {
  components: { LgMudarDepartamentoModal },
  async mounted() {
    this.$root.$on('departamentoChanged', (departamento) => {
      this.contextoRaiz = getContext()
    })
    if (!hasContext('departamento')) {
      this.$nextTick(() => {
        this.mudarDepartamento()
      })
    } else {
      this.contextoRaiz = getContext()
    }
  },

  computed: {
    routeName() {
      let route = this.$route;

      while (!!route) {
        const { meta } = this.$route;
        if (meta && meta.description) {
          return this.capitalizeFirstLetter(meta.description);
        }

        route = null;
      }
      return "";
    },
    usuario() {
      return this.contextoRaiz ? this.contextoRaiz.usuario : "";
    },
    departamento() {
      return this.contextoRaiz ? this.contextoRaiz.departamento : "";
    },
  },
  data() {
    return {
      activeNotifications: false,
      contextoRaiz: {},
      isAdminUser: isUserAdmin(),
      showDashboardMenu: true,
    };
  },
  methods: {
    capitalizeFirstLetter(value) {

      value = value.toLowerCase();

      if(value == 'da' || value == 'de' || value == 'do')
      return value;

      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      if (this.$sidebar && this.$sidebar.displaySidebar) {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      }
    },
    hideSidebar() {
      if (this.$sidebar && this.$sidebar.displaySidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    logout() {
      logout(() => {
        this.$router.replace("/login");
      });
    },
    mudarDepartamento() {
      this.$refs.modalDepartamento.show();
    },
  },
};
</script>
<style></style>
